module.exports = __webpack_public_path__ + "img/flor_2.50a1cd1f.svg";